export const defaultLocale = 'sv'

// PT is accessible via direct URL but hidden from the LocaleSwitcher until fully launched.
// See the filter in src/components/LocaleSwitcher.tsx.
export const locales = ['da', 'en', 'es', 'no', 'sv', 'pt'] as const
